/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ClientApp {
    "use strict";
    import ICustomBranding = Meevo.Model.ICustomBranding;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;

    interface IInheritedInfo {
        inheritedLevel: number;
        inheritedValue: string;
    }

    export class ClientAppContext extends Meevo.Components.CommonClasses.CommonContextBase {
        public urlRegExp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected copySecurityKey: string;
        protected deleteSecurityKey: string;
        protected changeAccessSecurityKey: string;
        protected changeOwnerSecurityKey: string;
        private validTaxItemName = true;
        preferencesSectionId: number = 2;
        private issingleLocation: boolean = false;
        private baseDataService: Meevo.Components.BaseClasses.IDataService;

        
        constructor(
            public controller: any,
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            public $scope: angular.IScope,
            protected $mdToast: angular.material.IToastService,
            protected $translate: angular.translate.ITranslateService,
            baseDataService: Meevo.Components.BaseClasses.IDataService,
            protected $filter: angular.IFilterService,
            public $q: ng.IQService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);
            this.todayDate = moment().startOf("day").toDate();
            // initialize end points
            this.baseEndpoint = appSettings.API_ENDPOINTS.clientApp;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/clientApp/sectionViews/";
            this.validTaxItemName = true;
            this.issingleLocation = this.isSingleLocation();
            this.baseDataService = baseDataService;
            this.initializeSections();
        }

        initializeSections(): void {
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_BRANDING + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new BrandingSection(0,
                    "SECTION_CLIENTAPP_BRANDING",
                    "branding.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "Branding?includeMetadata=true",
                    this.loggingService,
                    this.dataService,
                    this.$q,
                    this.busyService,
                    Meevo.Model.NounEnum.ClientAppBrandingTab,
                    this.identityService,
                    this.baseDataService,
                    this,
                    this.modalService,
                    this.securityKeys.INTEGRATION_CLIENTAPP_TAB_BRANDING// + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new SettingsSection(this.preferencesSectionId,
                    "SECTION_CLIENTAPP_SETTINGS",
                    "settings.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "Settings?includeMetadata=true",
                    this.loggingService,
                    this.securityChecker,
                    this.dataService,
                    Meevo.Model.NounEnum.ClientAppSettingsTab,
                    this.identityService,
                    this.baseDataService,
                    this.modalService,
                    this.securityKeys.INTEGRATION_CLIENTAPP_TAB_SETTINGS,// + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CUSTOMBRANDEDAPP + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new CustomSettingsSection(3,
                    "SECTION_CLIENTAPP_CUSTOM_SETTINGS",
                    "customSettings.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "Settings?includeMetadata=true",
                    this.loggingService,
                    this.securityChecker,
                    this.dataService,
                    this.$q,
                    this.busyService,
                    Meevo.Model.NounEnum.ClientAppCustomSettingsTab,
                    this.identityService,
                    this.baseDataService,
                    this.modalService,
                    this.securityKeys.INTEGRATION_CUSTOMBRANDEDAPP,// + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new InAppPromotionsSection(4,
                    "SECTION_CLIENTAPP_IN_APP_PROMOTIONS",
                    "inAppPromotions.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "Promotion",
                    this.loggingService,
                    this.dataService,
                    this.$q,
                    this.busyService,
                    Meevo.Model.NounEnum.ClientAppPromotionTab,
                    this.identityService,
                    this.baseDataService,
                    this.modalService,
                    this.$translate,
                    this.securityKeys.INTEGRATION_CLIENTAPP_TAB_INAPPPROMOTIONS,
                    this));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_SERVICEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ServiceMenuConfigSection(5,
                    "SECTION_CLIENTAPP_SERVICE_MENU_CONFIG",
                    "serviceMenuConfig.html",
                    false,
                    true,
                    "",
                    "serviceMenuConfig",
                    this.loggingService,
                    this.dataService,
                    this.baseDataService,
                    Meevo.Model.NounEnum.ClientAppServiceMenuTab,
                    this.identityService,
                    this.modalService,
                    this.$filter,
                    this.busyService,
                    this.securityKeys.INTEGRATION_CLIENTAPP_TAB_SERVICEMENUCONFIG,
                    this));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_PACKAGEMENUCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new PackageMenuConfigSection(6,
                    "SECTION_CLIENTAPP_PACKAGE_MENU_CONFIG",
                    "packageMenuConfig.html",
                    false,
                    true,
                    "",
                    "serviceCategoryDisplayPriority",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.ClientAppPackageMenuTab,
                    this.identityService,
                    this.baseDataService,
                    this.modalService,
                    this.$filter,
                    this.busyService,
                    this.securityKeys.INTEGRATION_CLIENTAPP_TAB_PACKAGEMENUCONFIG,
                    this
                ))
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_VIEWBIOCONFIG + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ViewBioConfigSection(7,
                    "SECTION_CLIENTAPP_VIEW_BIO_CONFIG",
                    "viewBioConfig.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "viewBioConfig",
                    this.loggingService,
                    this.dataService,
                    this.baseDataService,
                    Meevo.Model.NounEnum.ClientAppViewBioTab,
                    this.identityService,
                    this.modalService,
                    this.busyService,
                    this.$rootScope,
                    this.$mdToast,
                    this.$translate,
                    this.appSettings,
                    this.securityKeys.INTEGRATION_CLIENTAPP_TAB_VIEWBIOCONFIG,// + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this));
            }
            this.activate();
        }

        selectSection(item): void {
            super.selectSection(item);
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            //this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            //this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            //this.addSecurityKey = baseKey +
            //    ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            //this.copySecurityKey = baseKey +
            //    ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);

        }

        initializeHeader(model: any): void {
            //let businfoModel = <Meevo.Model.BusinessInfo>model;
            //this.headerContent = businfoModel.storeName;
        }

        fileTypesEnum = Meevo.Model.FileTypes;
        bindBusinessInfoImage(url: string) {
            if (this.selectedSection && this.selectedSection.model && this.selectedSection.model.businessLogoObj) {
                let fMetadata = <Model.IStorageFile>this.selectedSection.model.businessLogoObj;
                if (fMetadata) {
                    url = this.searchFile(fMetadata, "Source", url);
                }
            }
            if (!url) {
                url = 'assets/images/photo_not_available.svg';
            }
            return url;
        }

        bindImageObj(propName: string, url: string) {
            if (this.selectedSection && this.selectedSection.model && this.selectedSection.model[propName]) {
                let fMetadata = <Model.IStorageFile>this.selectedSection.model[propName];
                if (fMetadata) {
                    url = this.searchFile(fMetadata, "Source", url);
                }
            }
            if (!url) {
                url = 'assets/images/photo_not_available.svg';
            }
            return url;
        }

        bindElementImageObj(imageObj: object, url: string) {
            let fMetadata: Model.IStorageFile = <Model.IStorageFile>imageObj;
            if (fMetadata) {
                url = this.searchFile(fMetadata, "Source", url);
            }
            if (!url) {
                url = 'assets/images/photo_not_available.svg';
            }
            return url;
        }

        translateEffectiveLevel(level: number): string {
            let ret: string = "Location";
            switch (level) {
                case 0:
                    ret = "System";
                    break;
                case 1:
                    ret = "Tenant";
                    break;
                case 2:
                    ret = "BusinessType";
                    break;
            }
            return ret;
        }

        translateRule(rule: number): string {
            return rule === 2117 ? "Off Override" : "Lowest Level";
        }

        translateSettable(setLevels: number): string {
            let ret: string = "";
            if ((setLevels & 1) === 1) ret += "Tenant";
            if ((setLevels & 2) === 2) ret += " | BusinessType";
            if ((setLevels & 4) === 4) ret += " | Location";
            return ret;
        }

        getNextInheritedInfo(settingModel: Meevo.Model.SettingsDto): IInheritedInfo {

            let ret: IInheritedInfo;

            return ret;
        }

        showSettingInfo(fieldName: string, settingModel: Meevo.Model.SettingsDto) {

            let setting = _.find(settingModel.settings, setting => setting.displayName.toUpperCase() === fieldName.toUpperCase());
            if (Model.Guard.isNothing(setting)) return;
            let message: string = '';
            if ((setting.metadata.effectiveLevel & 4) == 0)
                message = 'This setting cannot be set by a location';
            else if (setting.metadata.calculationRule == Meevo.Model.OverrideRuleEnum.LowestLevel)
                if (setting.metadata.effectiveLevel == 4)
                    message = `You have overridden this setting.`; //Need more info to tell the next value up  'The inherited value is `;
                else
                    message = `You can edit this setting.  Its value of ${setting.effectiveValue} comes from the ${this.translateEffectiveLevel(setting.metadata.effectiveLevel)}`;
            else //This is the offoveride case
                if (setting.metadata.effectiveLevel)
                    message = `You have overridden this setting.`;
                else
                    message = `You can not edit this setting.  This setting was turned off at the ${this.translateEffectiveLevel(setting.metadata.effectiveLevel)}`;

            let debugMessage: string = !this.identityService.inTestOrTrainingMode() ? '' : `<br/><br>
                                        DEBUG INFO
                                        System Value=${setting.metadata.systemValue} <br\> 
                                        Tenant Value=${setting.metadata.tenantValue} <br\> 
                                        BusinessType Value=${setting.metadata.businessTypeValue} <br\> 
                                        Location Value=${setting.metadata.locationValue} <br\> 
                                        Effective Level=${this.translateEffectiveLevel(setting.metadata.effectiveLevel)}<br\>
                                        Rule=${this.translateRule(setting.metadata.calculationRule)}<br/>
                                        Setting Settable=${this.translateSettable(setting.settableLevels)}`;

            let displayMessage: string = `<div> ${message}${debugMessage}</div>`;

            this.modalService.showCustom({
                clickOutsideToClose: true,
                escapeToClose: true,
                hasBackdrop: false,
                template: displayMessage
            });

        }

        get isReadonly(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }

        add() {
            this.setMode(Meevo.Model.MaintenanceFormState.Adding);
            //TODO: RESET MODEL
            this.selectedSection.model = {};
        }

        cancel() {
            this.setMode(Meevo.Model.MaintenanceFormState.Pending);
            super.cancel();
        }

        get showEdit(): boolean {
            if (this.mode = Meevo.Model.MaintenanceFormState.Adding) {
                return false;
            }
            else 
                return this.selectedSection !== null && !this.selectedSection.handlesOwnCrud && this.isReadonly;
        }

        get showCancel(): boolean {
            return (this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud) || this.isReadonly || this.selectedSection.isReadonly;
        }

        get showSave(): boolean {
            return (this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud);
        }

        canCancelLogic(): boolean {
            return (this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud) || this.isReadonly || this.selectedSection.isReadonly;
        }

        canSaveLogic(): boolean {
            return (this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud);
        }

        canEditLogic(): boolean {
            return (this.selectedSection !== null && !this.selectedSection.handlesOwnCrud && this.isReadonly)
                || (this.selectedSection !== null && this.selectedSection.handlesOwnCrud && this.selectedSection.isReadonly);
        }
    }
}